import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ToolsService } from 'src/app/service/tools/tools.service';
import { Subscription } from 'rxjs';
import { ToolInventoryTransferService } from '../tool-inventory-transfer.service';
import { SelectedDataModel } from '../tool-inventory-transfer.model';
import { ToastService } from 'src/app/service/shared/toast/toast.service';

@Component({
  selector: 'app-tool-inventory-id-transfer-search',
  templateUrl: './tool-inventory-id-transfer-search.component.html',
  styleUrls: ['./tool-inventory-id-transfer-search.component.scss'],
})
export class ToolInventoryIdTransferSearchComponent implements OnInit, OnDestroy {
  @ViewChild('searchinput') searchinput: ElementRef;

  search: '';

  toolList = [];
  selectedItems: Array<SelectedDataModel> = [];

  searchIgnoreKeys = ['Escape', 'ArrowDown', 'ArrowUp', 'Enter'];

  subscription: Subscription;

  constructor(
    private toolsService: ToolsService,
    private toolInventoryTransferService: ToolInventoryTransferService,
    private toastService: ToastService,
  ) { }

  ngOnInit(): void {
    this.subscription = this.toolInventoryTransferService.selectedInventoryItems.subscribe(data => {
      this.selectedItems = data;
    });
  }

  ngAfterViewInit() {
    this.focusSearchInput();
  }

  ngOnDestroy(): void { }

  handleSubmit(event: Event) {
    if (!event || !(event.target instanceof HTMLInputElement)) return;

    const input = event.target as HTMLInputElement;
    const inputValue = input.value.trim();
    if (!inputValue) return;

    this.searchinput.nativeElement.value = '';

    // Convert each ID to a number
    const toolIdList = inputValue
      .split(',')
      .map(x => Number(x.trim()))
      .filter(x => !isNaN(x));

    toolIdList.forEach(toolId => this.addToolIdToTransferList(toolId));
  }

  addToolIdToTransferList(toolId: number) {
    const toolIdSelected: SelectedDataModel = { id: `T${toolId}`, toolId: 0, description: '' };
    this.toolInventoryTransferService
      .add(toolIdSelected, true)
      .then(response => {
        this.toastService.showToast(`${toolId} was successfully added to transfer list.`, 'success');
      })
      .catch(error => {
        console.error('this is the error from add()', error);
        this.toastService.showToast(`${toolId}: Failed due to ${error.statusText || 'Unknown Error'}`, 'error');
      });
  }

  focusSearchInput() {
    this.searchinput.nativeElement.focus();
  }
}
